import {
  AffiliateCommissionStatus,
  AffiliateEntity,
  AffiliateRecurringType,
  AffiliateRequestStatus,
  AffiliateUserResponse,
  AffiliateUserType,
} from '@monorepo/types';

export type AffiliatesPaginateFilter = Partial<{
  email: string;
  type: AffiliateUserType[];
  requestStatus: AffiliateRequestStatus[];
}>;

export const AutomaticStatuses = [AffiliateCommissionStatus.Approved];

export type AffiliateUserWithDetails = AffiliateUserResponse &
  Partial<AffiliateEntity> & {
    discountPercentage: number;
    commissionPercentage: number;
    totalCommissions: number;
    recurringType: AffiliateRecurringType;
    isSplitActive?: boolean;
    canUseSplit?: boolean;
  };

export type AffiliatesAdminSearchableKeys = 'email';
